module.exports = __webpack_public_path__ + "img/duoxuekezhuanzhen.c39d5636.jpg";